import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';

@Feature()
export class PasteFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    public async paste() {
        const copyPasteManager = await this.getAppServices().editableServiceLayer?.copyPasteManager?.promise();
        if (this.editorInstance?.isEditing) {
            copyPasteManager?.pasteForMobile();
            this.getAppServices().viewableServiceLayer.toolbarStateManager.isMobileToolbarClick = true;
            return;
        }

        copyPasteManager?.triggerPasteEvent();
    }
}
